import React from "react"
import styled from "styled-components"
import Img from "gatsby-image"

const WhoWeAreSection = styled.section`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
  grid-template-rows: 100px auto 32px;
  /* grid-template-areas: ""; */
  padding: 60px 200px;
  width: 100%;
  @media only screen and (max-width: 1100px) {
    padding: 60px 120px;
  }
  @media only screen and (max-width: 1000px) {
    padding: 60px 108px;
  }
  @media only screen and (max-width: 900px) {
    padding: 60px 96px;
  }
  @media only screen and (max-width: 800px) {
    padding: 60px 80px;
  }
  @media only screen and (max-width: 700px) {
    padding: 40px 64px;
    display: flex;
    flex-direction: column;
  }
  @media only screen and (max-width: 600px) {
    padding: 40px 48px;
  }
  @media only screen and (max-width: 500px) {
    padding: 40px 36px;
  }
  @media only screen and (max-width: 400px) {
    padding: 40px 24px;
  }

  .img {
    grid-column: 3 / 7;
    grid-row: 1 / 2;
    width: 550px;
    height: 367px;
    justify-self: end;
    @media only screen and (max-width: 700px) {
      width: 100%;
    }
  }
`

const TextBox = styled.div`
  grid-column: 1 / 5;
  grid-row: 2 / 4;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-self: end;
  border: 1px solid #461459;
  background-color: #fffefd;
  box-shadow: 4px 4px 0px #310542;
  padding: 32px 42px;
  z-index: 2;

  h2 {
    font-family: "Tinos";
    font-size: 22px;
    font-style: italic;
    font-weight: 700;
    line-height: 25px;
    letter-spacing: 0em;
    margin-bottom: 16px;
    color: #989085;
  }

  p.headline {
    max-width: 680px;
    font-family: "Amasis", serif;
    font-size: 26px;
    font-style: normal;
    font-weight: 700;
    line-height: 33px;
    margin-bottom: 8px;
  }
  p.description {
    max-width: 660px;
    font-size: 14px;
    font-weight: 400;
    line-height: 26px;
  }
  @media only screen and (max-width: 1000px) {
    h2 {
      font-size: 20px;
    }
    p.headline {
      font-size: 24px;
    }
    p.description {
      font-size: 14px;
    }
  }
  @media only screen and (max-width: 700px) {
    margin-top: -10%;
  }
  @media only screen and (max-width: 600px) {
    h2 {
      font-size: 18px;
    }
    p.headline {
      font-size: 22px;
    }
    p.description {
      font-size: 13px;
    }
  }
  @media only screen and (max-width: 400px) {
    h2 {
      font-size: 17px;
    }
    p.headline {
      font-size: 21px;
    }
    p.description {
      font-size: 12px;
    }
  }
`

const PictureBox = styled.img``
// a + ' ' + b
// `${a} ${b}`
const WhoWeAre: React.FC<{
  whoWeAreHeader: string
  whoWeAreDescription: string
  heroImageFluid: any
}> = function ({ whoWeAreHeader, whoWeAreDescription, heroImageFluid }) {
  return (
    <WhoWeAreSection>
      <Img fluid={heroImageFluid} className="img" />
      {/* <PictureBox src={`${heroImageURL}?fit=pad&w=550&h=367`} /> */}
      <TextBox>
        <h2>Who We Are</h2>
        <p className="headline">{whoWeAreHeader}</p>
        <p className="description">{whoWeAreDescription}</p>
      </TextBox>
    </WhoWeAreSection>
  )
}

export default WhoWeAre
